<template>
  <nav class="flex w-full bg-secondary py-4">
    <router-link to="/" class="text-white font-bold ml-4 text-2xl select-none cursor-pointer">
          Nailit
        </router-link>
    <ul class="flex w-full justify-end items-center gap-8 pr-4">
      <li class="w-fit">
        <router-link to="/" class="text-white hover:underline">Accueil</router-link>
      </li>
      <li class="w-fit">
        <router-link to="/features" class="text-white hover:underline">Fonctionnalités</router-link>
      </li>
      <li>
        <router-link to="/pricing" class="text-white hover:underline">Tarifs</router-link>
      </li>
      <li>
        <router-link to="/blog" class="text-white hover:underline">Blog</router-link>
      </li>
      <li>
        <router-link to="/contact" class="text-white hover:underline">Contact</router-link>
      </li>
      <li v-if="!isLoggedIn">
        <router-link to="/login" class="text-primary font-bold hover:underline">Se connecter</router-link>
      </li>
      <li v-else>
        <div class="relative">
          <button
            ref="userButton"
            @click="toggleUserMenu"
            class="!text-white text-xl flex items-center !p-0 !m-0 cursor-pointer !bg-transparent "
          >
            <i class="fa-solid fa-user-circle text-2xl"></i>
          </button>
          <ul
            ref="userMenu"
            v-if="isUserMenuOpen"
            class="absolute right-0 mt-2 bg-gray-800 text-white rounded-xl shadow-lg w-fit z-1"
          >
            <li
              @click="$router.push('/planning')"
              class="px-4 py-2 hover:bg-gray-700 cursor-pointer rounded-xl whitespace-nowrap"
            >
              Accéder au planning
            </li>
            <li
              @click="$router.push('/account')"
              class="px-4 py-2 hover:bg-gray-700 cursor-pointer rounded-xl whitespace-nowrap"
            >
              Mon compte
            </li>
          </ul>
        </div>
      </li>
    </ul>
  </nav>
</template>

<script>
import { onAuthStateChanged, getAuth } from "firebase/auth";

export default {
  name: 'ShowcaseNavbar',
  data() {
    return {
      isLoggedIn: false,
      isUserMenuOpen: false,
    };
  },
  methods: {
    toggleUserMenu() {
      this.isUserMenuOpen = !this.isUserMenuOpen;
    },
    closeUserMenu() {
      this.isUserMenuOpen = false;
    },
    handleClickOutside(event) {
      const menu = this.$refs.userMenu;
      const button = this.$refs.userButton;
      if (menu && !menu.contains(event.target) && button && !button.contains(event.target)) {
        this.closeUserMenu();
      }
    },
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);

    const auth = getAuth();
    this.unsubscribe = onAuthStateChanged(auth, (user) => {
      this.isLoggedIn = !!user;
    });
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleClickOutside);

    if (this.unsubscribe) this.unsubscribe();
  }
};
</script>